import { useCallback } from 'react'

import Step from '../../../../../../../../../features/components/Forms/StepForm/Step'
import NoOverlappingGamTargetingValidationMessage from '../../../../components/NoOverlappingGamTargetingValidationMessage'
import InventoryAvailabilitySpoiler from '../../../../components/InventoryAvailabilitySpoiler'
import InventorySelectionRadioBlocks from '../../../../components/InventorySelectionRadioBlocks'
import InventoryOverviewSpoiler from '../../../../../components/InventoryOverviewSpoiler'

import { RIGHT_INVENTORY_SELECT } from '../../../../fields'

const fields = [RIGHT_INVENTORY_SELECT]

const InventoryTargetingStep = ({ formik, onValidationChange, handleStepChange }) => {
  const { values } = formik

  const handleContinue = useCallback(() => {
    handleStepChange(fields)
  }, [handleStepChange])

  return (
    <Step stepTitle="Do you want to target ad inventory with this line item?" handleContinue={handleContinue}>
      <InventoryOverviewSpoiler />
      <NoOverlappingGamTargetingValidationMessage formValues={values} onValidationChange={onValidationChange} />

      <InventorySelectionRadioBlocks
        formik={formik}
        allInventoryChildren={<InventoryAvailabilitySpoiler formikValues={values} />}
        specificInventoryChildren={<InventoryAvailabilitySpoiler formikValues={values} />}
      />
    </Step>
  )
}

export default InventoryTargetingStep
